import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { ProjectService } from '../../providers';
import { Mote, MotesPaths, PlanType } from '../../models';

@Component({
    selector: 'preview-banner',
    templateUrl: './preview-banner.component.html',
    styleUrls: ['./preview-banner.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class PreviewBannerComponent implements OnInit {

    @Input('tour') set setTour(tour: Mote) {
        this.init(tour);
    }

    @Output() isVisibleChange = new EventEmitter<boolean>();

    public creatorPlan: PlanType;
    public isVisible: boolean;

    // Expose to view
    public PlanType = PlanType;
    public MotesPaths = MotesPaths;

    constructor(private projectService: ProjectService) { }

    ngOnInit(): void {
    }

    private async init(tour: Mote) {
        this.isVisible = false;
        this.isVisibleChange.emit(this.isVisible);
        if(!tour || tour.key == MotesPaths.DEFAULT_TOUR_KEY) return;

        const project = await this.projectService.getProject(tour.project);
        this.creatorPlan = project?.creatorPlan;

        this.isVisible = this.creatorPlan && !tour.publishedOn;
        this.isVisibleChange.emit(this.isVisible);
    }

}
